/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PdfExportResponseStatusEnum } from './PdfExportResponseStatusEnum';
import {
    PdfExportResponseStatusEnumFromJSON,
    PdfExportResponseStatusEnumFromJSONTyped,
    PdfExportResponseStatusEnumToJSON,
    PdfExportResponseStatusEnumToJSONTyped,
} from './PdfExportResponseStatusEnum';

/**
 * 
 * @export
 * @interface PdfExportResponse
 */
export interface PdfExportResponse {
    /**
     * 
     * @type {PdfExportResponseStatusEnum}
     * @memberof PdfExportResponse
     */
    status: PdfExportResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PdfExportResponse
     */
    dataDownloadId: string;
}



/**
 * Check if a given object implements the PdfExportResponse interface.
 */
export function instanceOfPdfExportResponse(value: object): value is PdfExportResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if ((!('dataDownloadId' in (value as Record<string, any>)) && !('data_download_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataDownloadId'] === undefined && (value as Record<string, any>)['data_download_id'] === undefined)) return false;
    return true;
}

export function PdfExportResponseFromJSON(json: any): PdfExportResponse {
    return PdfExportResponseFromJSONTyped(json, false);
}

export function PdfExportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfExportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': PdfExportResponseStatusEnumFromJSON(json['status']),
        'dataDownloadId': json['data_download_id'],
    };
}

export function PdfExportResponseToJSON(json: any): PdfExportResponse {
    return PdfExportResponseToJSONTyped(json, false);
}

export function PdfExportResponseToJSONTyped(value?: PdfExportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': PdfExportResponseStatusEnumToJSON(value['status']),
        'data_download_id': value['dataDownloadId'],
    };
}

